import React from 'react';
import type { CurrencyCode } from '@noths/polaris-client-localisation';
import { BlocksHeader } from '@noths/polaris-client-ribbons-design-system';

import type { CatServiceAPIProductOptionValue } from 'src/services/cat-service-api/types/CatServiceAPIProductOption';
import { getOptionAmount } from 'src/utils/price';

interface ToggleButtonProps {
  currency: CurrencyCode;
  isSelected: boolean;
  onClick: (value: CatServiceAPIProductOptionValue | null) => void;
  onFocus?: VoidFunction;
  value: CatServiceAPIProductOptionValue;
}

export const ToggleButton = ({
  currency,
  isSelected,
  onClick,
  onFocus,
  value,
}: ToggleButtonProps) => {
  const { value: price } = getOptionAmount(currency, value.priceModifier);

  const handleOnClick = () => {
    const newValue = isSelected ? null : value;

    onClick(newValue);
  };

  return (
    <BlocksHeader
      currency={currency}
      isSelected={isSelected}
      label={value.name}
      onClick={handleOnClick}
      onFocus={onFocus}
      price={price}
      variant="check"
    />
  );
};
